var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaleActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 52,
    viewBox: "0 0 38 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80091 5C7.19857 6.89912 8.93088 8.3333 11 8.3333H27.2378C26.8101 4.58828 23.5357 1.6667 19.5715 1.6667H7.57143C7.57143 2.58584 8.34025 3.3333 9.28575 3.3333C9.75886 3.3333 10.1429 3.70664 10.1429 4.1667C10.1429 4.62666 9.75886 5 9.28575 5H6.80091ZM28.1429 10H11C7.69147 10 5 7.3833 5 4.1667C5 3.70664 5.38401 3.3333 5.85711 3.3333H6.31746C6.02425 2.84248 5.85711 2.27334 5.85711 1.6667V0.833301C5.85711 0.37334 6.24112 0 6.71432 0H19.5715C24.77 0 29 4.1125 29 9.1667C29 9.62666 28.6169 10 28.1429 10Z",
    fill: "#FF5B91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8229 15L8.00183 13.4432L8.41285 14.2212L8 13.444C8.03118 13.4284 11.1652 11.8855 11.1652 9H13C13 12.9724 8.99353 14.9182 8.8229 15Z",
    fill: "#FF5B91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1771 15C28.0064 14.9182 24 12.9724 24 9H25.8349C25.8349 11.8855 28.9679 13.4284 29 13.444L28.1771 15Z",
    fill: "#FF5B91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 20H28V18.25H29C30.103 18.25 31 17.4651 31 16.5001C31 15.5349 30.103 14.75 29 14.75H28V13H29C31.206 13 33 14.5698 33 16.5001C33 18.4302 31.206 20 29 20Z",
    fill: "#FF5B91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 20H7.99993C5.79401 20 4 18.4302 4 16.5001C4 14.5698 5.79401 13 7.99993 13H9V14.75H7.99993C6.89697 14.75 6.00002 15.5349 6.00002 16.5001C6.00002 17.4651 6.89697 18.25 7.99993 18.25H9V20Z",
    fill: "#FF5B91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5096 30C13.5887 30 9.22237 26.4755 8.3352 21.4753C8.28096 21.1691 8.23984 20.8603 8.21359 20.5506L8.00267 17.8151L8 9H9.75003V17.7478L9.95737 20.4098C9.97839 20.6599 10.0125 20.9154 10.0571 21.1691C10.8849 25.8281 15.3509 28.945 20.0094 28.1184C23.9163 27.3625 26.8247 24.0497 27.0681 20.0642L27.2526 17.6795L27.2501 9H29V17.7478L28.8137 20.1858C28.5232 24.9534 25.0337 28.9284 20.3288 29.8381C19.7181 29.9466 19.1091 30 18.5096 30Z",
    fill: "#FF5B91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8006 51.1005C12.3293 51.1005 11.9473 50.7185 11.9473 50.2472V34.2216C11.9473 33.7497 12.3296 33.3682 12.8006 33.3682H12.9457C13.3553 33.2983 13.6565 32.9407 13.6539 32.5209V28.0605H15.3606V32.5149C15.3683 33.6217 14.6643 34.5859 13.6539 34.9418V50.2472C13.6539 50.7185 13.2718 51.1005 12.8006 51.1005Z",
    fill: "#FF5B91"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0608 51.04C25.532 51.04 25.9141 50.658 25.9141 50.1867V34.1611C25.9141 33.6892 25.5318 33.3077 25.0608 33.3077H24.9157C24.5061 33.2378 24.2049 32.8802 24.2075 32.4604V28H22.5008V32.4544C22.4931 33.5612 23.1971 34.5254 24.2075 34.8813V50.1867C24.2075 50.658 24.5895 51.04 25.0608 51.04Z",
    fill: "#FF5B91"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5689 51.1002C0.254705 51.1002 0 50.8455 0 50.5313V41.7135C0 37.8821 2.8638 34.6095 6.6628 34.101L7.6237 34.0352L7.7372 35.7385L6.8326 35.7982C3.9339 36.1873 1.7067 38.7328 1.7067 41.7135V49.9624C1.7067 50.5907 1.19729 51.1002 0.5689 51.1002Z",
    fill: "#FF5B91"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6674 51.065C36.9816 51.065 37.2363 50.8103 37.2363 50.4961V41.6783C37.2363 37.8469 34.3725 34.5743 30.5735 34.0658L29.6126 34L29.4991 35.7033L30.4037 35.763C33.3024 36.1521 35.5296 38.6976 35.5296 41.6783V49.9272C35.5296 50.5556 36.039 51.065 36.6674 51.065Z",
    fill: "#FF5B91"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 37.0363L13.3875 36.0016C14.7768 37.511 16.8228 38.3769 19.0004 38.3769C21.178 38.3769 23.2242 37.511 24.6134 36L25.9134 37.2304C24.1808 39.1139 21.716 40 19.0004 40C16.284 40 13.7326 38.9199 12 37.0363Z",
    fill: "#FF5B91"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9839 44L7.22009 36.8006C6.74015 36.069 6.49217 35.2222 6.50019 34.3466C6.50019 31.9537 8.42971 30 10.8018 30H14.5V31.7998H10.8027C9.41092 31.7998 8.27858 32.9463 8.27858 34.3556C8.27327 34.8775 8.41909 35.3751 8.69905 35.8009L13.461 42.9975L11.9839 44Z",
    fill: "#FF5B91"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5164 44C24.6979 43.445 24.4783 42.3347 25.0241 41.5099L28.8034 35.799C29.0816 35.3751 29.2274 34.8784 29.222 34.3645C29.222 32.9472 28.0896 31.7998 26.6977 31.7998H23V30H26.6977C29.07 30 30.9998 31.9537 30.9998 34.3556C31.0086 35.2213 30.7598 36.069 30.2825 36.798L25.5164 44Z",
    fill: "#FF5B91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleActive);
export default __webpack_public_path__ + "static/media/maleActive.3a092d92.svg";
export { ForwardRef as ReactComponent };